<template>
  <div style="margin: 0 24px 8px;">
    <el-form ref="formRef" :model="BrandForm" label-width="auto" label-position="right">
      <el-form-item label="品牌名称：">
        <el-input v-model="BrandForm.name" placeholder="请输入品牌名称" />
      </el-form-item>
      <el-form-item label="备注：">
        <el-input v-model="BrandForm.remark" placeholder="请输入备注" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"/>
      </el-form-item>
      <el-form-item label="排序：">
        <el-input v-model="BrandForm.orderNum" placeholder="请输入数值" />
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center; margin-top: 24px;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData, getFormData } from "@/api/api"
import { addOrUpdateBrand, getSysPositionList } from "@/api/url";
import { phoneReg } from "@/assets/shared/reg-constant";

export default {
  name: "UserFromDialog",
  props: {
    value: Object
  },
  data() {
    return {
      BrandForm: this.value.BrandForm,
      idx: this.value.ids,
    }
  },
  methods: {

    cancel() {
      this.$emit("close");
    },
    summit() {
      console.log(this.idx)
      if(!this.BrandForm.name) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请输入品牌名称',
          type: 'warning'
        });
        return false
      }
      if(!this.BrandForm.orderNum) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请输入排序数值，数值越大越靠前',
          type: 'warning'
        });
        return false
      }
      let param = {}

      param['id'] = this.idx > -1?this.BrandForm.id:0;
      param['name'] = this.BrandForm.name;
      param['remark'] = this.BrandForm.remark;
      param['orderNum'] = this.BrandForm.orderNum;
      postFormData(addOrUpdateBrand, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    },

    // getPositionList() {
    //   getFormData(getSysPositionList).then(data=> {
    //     this.positionTypeArray = data.data
    //   })
    // },



  },
  mounted() {

  }
}
</script>

<style scoped>

</style>
